<section class="page-shell">
  <header class="page-header">
    <h4>Recherche Investisseur</h4>

    <div class="page-header-actions">
      <oui-button
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading() || !hasActiveFilters()">
        Recharger
      </oui-button>
    </div>
  </header>

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Recherche impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  <section class="content-grid">
    <article class="panel search-panel dbw-card dbw-card--xl">
      <h5>Filtres</h5>

      <div class="filters">
        <div class="filters-group">
          <div class="subtitle-1">Investisseur</div>
          <div class="filters-row">
            <oui-textfield
              label="InvestisseurId"
              type="number"
              [value]="investorIdFilter()"
              (valueChange)="onInvestorIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              label="Code investisseur"
              [value]="investorCodeFilter()"
              (valueChange)="onInvestorCodeFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              class="search-field-name"
              label="Nom / prénom investisseur"
              [value]="investorNameFilter()"
              (valueChange)="onInvestorNameFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-select-filter
              class="search-field-status"
              label="Statuts investisseur"
              type="list"
              listPlaceholder="Rechercher un statut"
              [listOptions]="investorStatusOptions"
              [value]="investorStatusFilter()"
              (valueChange)="onInvestorStatusFilterChange($event ?? [])">
            </oui-select-filter>
            <oui-textfield
              label="ArianeId"
              type="number"
              [value]="arianeIdFilter()"
              (valueChange)="onArianeIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
          </div>
        </div>
        <div class="filters-group">
          <div class="subtitle-1">Consultant</div>
          <div class="filters-row">
            <oui-textfield
              label="ConsultantId"
              type="number"
              [value]="consultantIdFilter()"
              (valueChange)="onConsultantIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              label="Code consultant"
              [value]="consultantCodeFilter()"
              (valueChange)="onConsultantCodeFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              class="search-field-name"
              label="Nom / prénom consultant"
              [value]="consultantNameFilter()"
              (valueChange)="onConsultantNameFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
          </div>
        </div>
      </div>
    </article>

    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h5>Résultats</h5>
          <p>
            @if (hasActiveFilters()) {
              @if (searchPending() || loading()) {
                Recherche en cours.
              } @else if (page()) {
                {{ page()?.totalCount ?? 0 }} investisseur(s) trouvé(s).
              } @else {
                Aucun résultat chargé.
              }
            } @else {
              Renseigner au moins un filtre pour lancer la recherche.
            }
          </p>
        </div>
      </div>

      @if (!hasActiveFilters()) {
        <dbw-state-card
          appearance="info"
          [compact]="true">
          <p>La recherche ne charge rien tant qu'aucun filtre n'est saisi.</p>
        </dbw-state-card>
      }

      @if (searchPending() || loading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Recherche Atlas en cours.</p>
        </dbw-state-card>
      }

      @if (!searchPending() && !loading() && hasActiveFilters() && page() && (page()?.items?.length ?? 0) === 0) {
        <div class="empty-state">Aucun investisseur ne correspond à la recherche courante.</div>
      }

      @if (!searchPending() && !loading() && (page()?.items?.length ?? 0) > 0) {
        <div class="table-shell">
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="page()?.items ?? []">
              <ng-container matColumnDef="investor">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Investisseur
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-investor-card
                    [id]="row.investorId"
                    [code]="row.investorCode || 'Code inconnu'"
                    [name]="row.displayName || 'Investisseur #' + row.investorId"
                    [statusCode]="row.statusCode"></dbw-investor-card>
                </td>
              </ng-container>

              <ng-container matColumnDef="birthDate">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Naissance
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.birthDate || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Statut
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-investor-status-tag [statusCode]="row.statusCode"></dbw-investor-status-tag>
                </td>
              </ng-container>

              <ng-container matColumnDef="consultant">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Consultant
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-consultant-card
                    [id]="row.consultantId"
                    [code]="row.consultantCode || '-'"
                    [name]="row.consultantName || '-'"
                    [statusCode]="row.consultantStatusCode"></dbw-consultant-card>
                </td>
              </ng-container>

              <ng-container matColumnDef="arianeId">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  ArianeId
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.arianeId ?? '-' }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </oui-table>

          <mat-paginator
            [length]="page()?.totalCount ?? 0"
            [pageIndex]="page()?.pageIndex ?? pageIndex()"
            [pageSize]="page()?.pageSize ?? pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      }
    </article>
  </section>
</section>
